import { render } from "./CrmListViewCreateDealModalFormItems.vue?vue&type=template&id=2add885e"
import script from "./CrmListViewCreateDealModalFormItems.vue?vue&type=script&lang=js"
export * from "./CrmListViewCreateDealModalFormItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__